import { Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FREQUENCY_OPTIONS } from "../../../core/constants/common";
import "./BranchSubmissionsSummaryModal.scss";

const SECTION_KEYS = FREQUENCY_OPTIONS.filter(({ key }) => key !== 'SUMMARY');

const ATTENTION_THRESHOLD = 90;

function getSectionTotals(sections, sectionKey) {
    const rows = sections?.[sectionKey] || [];
    const totals = rows.reduce((acc, row) => {
        acc.total += row.total ?? 0;
        acc.completed += row.statusCount?.COMPLETED ?? 0;
        return acc;
    }, { total: 0, completed: 0 });
    totals.percentage = totals.total > 0 ? (totals.completed / totals.total) * 100 : 0;
    return totals;
}

function getEntitiesRequiringAttention(sections) {
    const rows = sections?.SUMMARY || [];
    return rows
        .map((row) => {
            const total = row.total ?? 0;
            const completed = row.statusCount?.COMPLETED ?? 0;
            const percentage = total > 0 ? (completed / total) * 100 : 0;
            return { ...row, total, completed, percentage };
        })
        .filter((row) => row.percentage < ATTENTION_THRESHOLD)
        .sort((a, b) => a.percentage - b.percentage);
}

const BranchSubmissionsSummaryModal = ({ t, show, onHide, summary, frequencySummary }) => {
    const sections = summary?.sections;
    const frequencySections = frequencySummary?.sections ?? frequencySummary;
    const entitiesRequiringAttention = getEntitiesRequiringAttention(sections);
    const visibleSectionKeys = SECTION_KEYS.filter(
        ({ key }) => key !== 'HALF_YEARLY' || frequencySections?.HALF_YEARLY?.length > 0
    );

    const renderSectionStat = ({ key, labelKey }) => {
        const totals = getSectionTotals(frequencySections, key);
        return (
            <div className="branch-summary-modal-section-stat" key={key}>
                <div className="branch-summary-modal-section-stat__label">{t(labelKey)}</div>
                <div className="branch-summary-modal-section-stat__percentage" style={{ color: '#5abb6a' }}>
                    {totals.percentage.toFixed(1)}%
                </div>
                <div className="branch-summary-modal-section-stat__count">{totals.completed} / {totals.total}</div>
            </div>
        );
    };

    const renderEntityRow = (row) => {
        const roundedPercentage = Math.round(row.percentage);
        return (
            <div className="branch-summary-modal-entity-row" key={row.branchId}>
                <span className="branch-summary-modal-entity-row__name" title={row.branchName}>
                    {row.branchName}
                </span>
                <span className="branch-summary-modal-entity-row__count">{row.completed} / {row.total}</span>
                <div className="branch-summary-modal-entity-row__bar-track">
                    <div
                        className="branch-summary-modal-entity-row__bar-fill"
                        style={{
                            width: `${Math.max(roundedPercentage, roundedPercentage > 0 ? 6 : 0)}%`,
                            backgroundColor: '#5abb6a'
                        }}
                    />
                </div>
                <span className="branch-summary-modal-entity-row__percentage">{roundedPercentage}%</span>
            </div>
        );
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered className="branch-summary-modal">
            <Modal.Header closeButton>
                <Modal.Title>{t("DataCollectionSummary.label")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="branch-summary-modal-sections">
                    {visibleSectionKeys.map(renderSectionStat)}
                </div>
                <hr />
                <h6 className="branch-summary-modal-entities-title">{t("EntitiesRequiringAttention.label")}</h6>
                {entitiesRequiringAttention.length === 0 ? (
                    <p className="text-secondary mb-0">{t("Nodatafound.label")}</p>
                ) : (
                    <div className="branch-summary-modal-entities-list">
                        {entitiesRequiringAttention.map(renderEntityRow)}
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default withTranslation()(BranchSubmissionsSummaryModal);
